import { useSyncExternalStore } from 'react';

/**
 * The breakpoints of src/theme/media.css for components that must render
 * different markup (not just styles) per layout, such as the two-pane
 * Messages view. Keep the two in step (research.md §4).
 */
export const MEDIA = {
  compact: '(width < 768px)',
  wide: '(width >= 1024px)',
  notCompact: '(width >= 768px)',
} as const;

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const list = window.matchMedia(query);
      list.addEventListener('change', onChange);
      return () => list.removeEventListener('change', onChange);
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}

export const useIsWide = () => useMediaQuery(MEDIA.wide);
export const useIsCompact = () => useMediaQuery(MEDIA.compact);
